

















































import { Component, Vue, Prop } from "vue-property-decorator"
import { mapState } from "vuex"

@Component({
  computed: {
    ...mapState("BookingCandidate", {
      bookingCandidate: "bookingCandidate"
    }),
    ...mapState("Booking", {
      booking: "booking"
    })
  }
})
export default class CandidateDashboardConfirmScreen extends Vue {
  @Prop() questionnaire!: Questionnaire

  // bookingCandidate State
  bookingCandidate!: BookingCandidate
  // booking State
  booking!: Booking
  isLoading = false

  get shareCode() {
    return this.bookingCandidate?.share_code ?? this.booking?.share_code
  }

  claim() {
    this.isLoading = true

    this.$store
      .dispatch("Booking/candidate", {
        bookingOid: this.booking.object_id,
        bookingCandidateOid: this.bookingCandidate
          ? this.bookingCandidate.object_id
          : null
      })
      .then(() => {
        this.isLoading = false
        if (this.bookingCandidate.object_id) {
          this.$router.push({
            name: "candidate-booking-candidate-read",
            params: {
              bookingCandidateOid: this.bookingCandidate.object_id
            }
          })
        }
      })
  }

  goBack() {
    this.$emit("back")
  }
}
